/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetUserEtcCards200ResponseItemsInnerUser } from './get-user-etc-cards200-response-items-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetUserEtcCards200ResponseItemsInnerUserAccountGroup } from './get-user-etc-cards200-response-items-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetUserEtcCards200ResponseItemsInner
 */
export interface GetUserEtcCards200ResponseItemsInner {
    /**
     * User account ID
     * @type {string}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'userAccountId': string;
    /**
     * Card label (display name)
     * @type {string}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'status': GetUserEtcCards200ResponseItemsInnerStatusEnum;
    /**
     * 
     * @type {GetUserEtcCards200ResponseItemsInnerUser}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'user'?: GetUserEtcCards200ResponseItemsInnerUser | null;
    /**
     * Card creation date
     * @type {string}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'createdAt': string;
    /**
     * Last 4 digits of the ETC ID. Null when not yet assigned or unavailable.
     * @type {string}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'etcIdLastFourDigits'?: string | null;
    /**
     * 
     * @type {GetUserEtcCards200ResponseItemsInnerUserAccountGroup}
     * @memberof GetUserEtcCards200ResponseItemsInner
     */
    'userAccountGroup'?: GetUserEtcCards200ResponseItemsInnerUserAccountGroup | null;
}

export const GetUserEtcCards200ResponseItemsInnerStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type GetUserEtcCards200ResponseItemsInnerStatusEnum = typeof GetUserEtcCards200ResponseItemsInnerStatusEnum[keyof typeof GetUserEtcCards200ResponseItemsInnerStatusEnum];


